<div class="row" *ngIf="!sessionService.isAuthenticated()">
    <div class="col-lg-1"></div>
    <div class="col-md-12 col-lg-5">
        <div class="row justify-content-lg-center white-panel">
          <div class="col-md-12  col-lg-10">
            <div class="hightlight-banner">
              <img src="../../assets/paetep-screen-300.jpg"  title="PAETEP by Edulink"/>
            </div>
            <h3 class="hightlight-banner-text">If You Like PAETEP,<br> Consider Comply!</h3>
            <div class="hightlight-banner-list">
                <ul>
                  <li>20+ PDE Mandated Trainings</li>
                  <li>Act 55 School Safety and Security Trainings</li>
                  <li>Clearance Tracking</li>
                  <li>Act 48 Submissions to PERMS</li>
                  <li>Para Hour Tracking</li>
                  <li>Internal Request Management</li>
                  <li>And Much, Much, More!</li>
                </ul>

                <h5 class="text-center">Learn More about Comply and Request a Demo</h5>
                <p class="text-center"><a class="btn btn-primary hightlight-button" href="https://edulinksolutions.com/comply/" target="_blank"role="button">Comply</a></p>

            </div>
        </div>
        </div>
    </div>
    <div class="col-md-12 col-lg-5">
        <div class="row justify-content-lg-center white-panel">
            <div class="col-md-12 col-lg-10">
                <ui-view name="login-content"></ui-view>
            </div>
        </div>
    </div>
    <div class="col-lg-1"></div>
</div>
